import { Autocomplete, TextField } from '@mui/material';

import { useServerSearch } from '@/tracker/hooks/useServerSearch';
import { TaskRef } from '@/tracker/types';

type Props = {
  /** Стабильная функция поиска (action.bound стора) */
  search: (query: string) => Promise<TaskRef[]>;
  ariaLabel: string;
  /** Пункт «очистить» первым в списке, например «Без родителя»; не передан — пункта нет */
  noneLabel?: string;
  onSave: (taskKey: string | null) => void;
  onClose: () => void;
};

/** Выбор задачи поиском по ключу и названию */
const TaskPicker: React.FC<Props> = ({ search, ariaLabel, noneLabel, onSave, onClose }) => {
  const { query, setQuery, options, isLoading } = useServerSearch({ search });
  const none: TaskRef | null = noneLabel ? { key: '', summary: noneLabel } : null;

  return (
    <Autocomplete
      size="small"
      openOnFocus
      options={none ? [none, ...options] : options}
      // Фильтрует сервер
      filterOptions={(all) => all}
      loading={isLoading}
      loadingText="Поиск…"
      noOptionsText="Ничего не нашлось"
      value={null}
      inputValue={query}
      onInputChange={(_, value, reason) => reason === 'input' && setQuery(value)}
      getOptionLabel={(option) => option.key}
      renderOption={({ key: _, ...props }, option) => (
        <li key={option.key || 'none'} {...props}>
          {option === none ? (
            <i>{option.summary}</i>
          ) : (
            <span>
              <b>{option.key}</b> {option.summary}
            </span>
          )}
        </li>
      )}
      onChange={(_, option) => {
        onClose();

        if (option) onSave(option.key || null);
      }}
      onBlur={onClose}
      // Esc при открытом списке Autocomplete забирает себе — отменяем правку сразу
      onClose={(_, reason) => reason === 'escape' && onClose()}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          placeholder="Ключ или название задачи"
          slotProps={{ htmlInput: { ...params.inputProps, 'aria-label': ariaLabel } }}
        />
      )}
    />
  );
};

export { TaskPicker };
